import { useState } from 'react';

import ModalBase, { ModalBaseProps } from '~components/ModalBase';

import { TABS } from './constants';
import ListedCompanyList from './ListedCompanyList';
import PublicCompanyList from './PublicCompanyList';
import * as S from './style';

interface Props extends ModalBaseProps {}

export default function ModalCompanyList({ isOpen, handleClose }: Props) {
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);

  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={handleClose}
      hasCloseButton
      maskClosable
      inlineCss={S.cssModalWrapper}>
      <S.Wrapper>
        <S.Title>기업리스트</S.Title>
        <S.Tabs>
          {TABS.map((tabName, index) => (
            <S.TabsItem
              key={`company-list-modal-tab${index}`}
              $active={index === currentTabIndex}
              onClick={() => setCurrentTabIndex(index)}>
              {tabName}
            </S.TabsItem>
          ))}
        </S.Tabs>

        {currentTabIndex === 0 ? <PublicCompanyList /> : <ListedCompanyList />}
      </S.Wrapper>
    </ModalBase>
  );
}
